/**
 * @file   src\components\BuyUps.tsx
 * @brief  Buy Ups component for selecting additional features/services.
 * @date   FEB, 2026
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { React, useState, useEffect } from '../utils/thirdpartyComponents';
import InputCheck from 'src/components/CWChecBoxLabel';

export interface BuyUpItem {
    id: string;
    title: string;
    description: string;
    price: number;
}

interface BuyUpsProps {
    buyUps?: BuyUpItem[];
    enableBuyUps: boolean;
    selectedBuyUps: string[];
    onEnableChange: (enabled: boolean) => void;
    onBuyUpToggle: (buyUpId: string) => void;
    subscriptionType?: number; // 1 for per wash, 2 for per month
}

const BuyUps: React.FC<BuyUpsProps> = ({
    buyUps = [],
    enableBuyUps,
    selectedBuyUps,
    onEnableChange,
    onBuyUpToggle,
    subscriptionType = 2
}) => {
    return (
        <div className="buy-ups-section">
            <div className="buy-ups-header mb-3">
                <InputCheck
                    id="enable-buy-ups"
                    name="enable-buy-ups"
                    type="checkbox"
                    label="Do you want to Customize your Wash?"
                    checked={enableBuyUps}
                    onChange={(e) => onEnableChange(e.target.checked)}
                />
            </div>

            {enableBuyUps && (
                <div className="buy-ups-list">
                    {buyUps.map((buyUp) => (
                        <div key={buyUp.id} className="buy-up-card">
                            <div className="buy-up-checkbox">
                                <input
                                    type="checkbox"
                                    id={`buy-up-${buyUp.id}`}
                                    checked={selectedBuyUps.includes(buyUp.id)}
                                    onChange={() => onBuyUpToggle(buyUp.id)}
                                />
                                <label htmlFor={`buy-up-${buyUp.id}`}></label>
                            </div>
                            <div className="buy-up-content">
                                <h6 className="buy-up-title">{buyUp.title}</h6>
                                <div
                                    className="buy-up-description"
                                    dangerouslySetInnerHTML={{ __html: buyUp.description }}
                                />
                                <div className="buy-up-price">${buyUp.price.toFixed(2)}</div>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default BuyUps;

